import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";
import { SessionHighlightUpcomingSmall } from "../../common_components/SessionHighlights";
import { Card, GrayCardTitle } from "../../common_components/Layout";
import Modal from "../../common_components/Modal";
import { PrimaryButton, SecondaryButton } from "../../common_components/Buttons";

// Api Calls
import ScheduledEventAPI from "../../../api/api_calls/ScheduledEventAPI";

function UpcomingSessionDetailsCard(props) {
    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId, sessionId } = useParams()

    // Reschedule Modal State
    const [rescheduleModalIsOpen, setRescheduleModalIsOpen] = useState(false);
    const toggleRescheduleModal = () => {
        setRescheduleModalIsOpen(!rescheduleModalIsOpen);
    }
    function onRescheduleComfirm() {
        async function requestReschedule() {
            const result = await ScheduledEventAPI.one_mission_request_reschedule({ missionId, sessionId, handleRedirect: navigate });

            if (result.success) {
                alert.show("Session canceled. Requested the user reschedule", { type: 'success' })
                navigate("/missions/" + missionId)
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        requestReschedule();
    }

    // Cancel Modal State
    const [cancelModalIsOpen, setCancelModalIsOpen] = useState(false);
    const toggleCancelModal = () => {
        setCancelModalIsOpen(!cancelModalIsOpen);
    }
    function onCancelConfirm() {
        async function cancelSession() {
            const result = await ScheduledEventAPI.one_mission_cancel_and_reject_user({ missionId, sessionId, handleRedirect: navigate });

            if (result.success) {
                alert.show("Session canceled. User has been rejected from project.", { type: 'success' })
                navigate("/missions/" + missionId)
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        cancelSession();
    }

    return (
        <Card>
            <GrayCardTitle title="Session Details" />
            <div className="individual-session-details-container">
                <SessionHighlightUpcomingSmall session={props.session} timezone={props.timezone} />
                <div className="timezone-text" >
                    Timezone: {props.timezone}
                </div>
            </div>
            <div className="session-button-row">
                <SecondaryButton text="Request Reschedule" onClick={toggleRescheduleModal} />
                <SecondaryButton text="Cancel & Reject User" onClick={toggleCancelModal} />
            </div>
            <div className="modal-holder">
                {rescheduleModalIsOpen && <RescheduleModal isOpen={rescheduleModalIsOpen} toggleModal={toggleRescheduleModal} onConfirm={onRescheduleComfirm} />}
                {cancelModalIsOpen && <CancelModal isOpen={cancelModalIsOpen} toggleModal={toggleCancelModal} onConfirm={onCancelConfirm} />}
            </div>

        </Card>
    )
}

function RescheduleModal(props) {
    var style = {
        maxWidth: "350px",
        gap: "32px"
    }

    if (window.innerWidth < 768) {
        style.maxWidth = "100%";
    }

    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen}>
            <Card style={style}>
                <div className="modal-title">
                    Request Reschedule?
                </div>
                <div className="modal-text mw-">
                    Cancel this session and request the user reschedule to another time slot?
                </div>
                <div className="button-row-right">
                    <PrimaryButton text="Confirm" onClick={props.onConfirm} />
                    <SecondaryButton text="Close" onClick={props.toggleModal} />
                </div>
            </Card>
        </Modal>
    )
}

function CancelModal(props) {
    var style = {
        maxWidth: "350px",
        gap: "32px"
    }

    if (window.innerWidth < 768) {
        style.maxWidth = "100%";
    }

    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen}>
            <Card style={style}>
                <div className="modal-title">
                    Cancel & Reject User?
                </div>
                <div className="modal-text mw-">
                    Cancel this session and reject user? They won't be able to reschedule or participate in this Project.                </div>
                <div className="button-row-right">
                    <PrimaryButton text="Confirm" onClick={props.onConfirm} />
                    <SecondaryButton text="Close" onClick={props.toggleModal} />
                </div>
            </Card>
        </Modal>
    )
}


export default UpcomingSessionDetailsCard;